import { useMemo } from 'react';
import { ImageURISource, Pressable, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { UserAvatar } from '../UserAvatar/UserAvatar';
import { colors, spacing } from '../../theme';

interface Props {
	items: {
		name: string;
		photoSource?: ImageURISource;
		onPress?: () => void;
	}[];
	maxAvatars: number;
	avatarSize: number;
	withNotShownCount?: boolean;
	style?: StyleProp<ViewStyle>;
}

export const UserAvatarsStack = ({
	avatarSize,
	maxAvatars,
	items,
	withNotShownCount,
	style,
}: Props) => {
	const toShowCount = maxAvatars > 0 ? maxAvatars : items.length;

	const displayedAvatars = useMemo(() => items.slice(0, toShowCount), [items, toShowCount]);

	const notShownCount = items.length - displayedAvatars.length;

	return (
		<View style={[styles.root, { marginRight: -spacing(displayedAvatars.length - 1) }, style]}>
			{displayedAvatars.map((item, avatarIndex) => (
				<Pressable
					key={`avatar-${avatarIndex}`}
					onPress={item.onPress}
					style={{
						transform: [{ translateX: -spacing(avatarIndex) }],
					}}
					disabled={!item.onPress}
				>
					<UserAvatar
						size={avatarSize}
						username={item.name}
						source={item.photoSource}
						style={{
							...styles.avatar,
						}}
					/>
				</Pressable>
			))}
			{withNotShownCount && notShownCount > 0 && (
				<UserAvatar
					colorize={false}
					size={avatarSize}
					username={`+ ${notShownCount}`}
					style={{
						...styles.avatar,
						transform: [{ translateX: -spacing(toShowCount) }],
					}}
				/>
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	avatar: {
		borderColor: colors.neutral300,
		borderWidth: 1,
	},
});
